<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Campo de Batalha
      </span>

      <h3 class="text-center my-5">Campo de Batalha</h3>
    </header>

    <section>
      <h4 class="mb-3">Horários de Batalha</h4>

      <div
        v-for="time in times"
        :key="time.id"
        class="d-flex flex-column flex-md-row mb-3"
      >
        <img :src="time.img" :alt="time.value" class="mr-md-3" />
        <div>
          <h4>
            <strong>{{ time.value }}</strong>
          </h4>
          <p>{{ time.desc }}</p>
        </div>
      </div>
    </section>

    <section class="mt-5">
      <h4 class="mb-3">Climas do Campo de Batalha</h4>

      <div
        v-for="weather in weathers"
        :key="weather.id"
        class="d-flex flex-column flex-md-row mb-3"
      >
        <img :src="weather.img" :alt="weather.value" class="mr-md-3" />
        <div>
          <h4>
            <strong>{{ weather.value }}</strong>
          </h4>
          <p>{{ weather.desc }}</p>
        </div>
      </div>
    </section>

    <section class="mt-5">
      <h4 class="mb-3">Tipos de terrenos</h4>

      <div
        v-for="area in areas"
        :key="area.id"
        class="d-flex flex-column flex-md-row mb-3"
      >
        <img :src="area.img" :alt="area.value" class="mr-md-3" />
        <div>
          <h4>
            <strong>{{ area.value }}</strong>
          </h4>
          <p>{{ area.desc }}</p>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { areas, times, weathers } from '../data/field'

export default {
  name: 'battlefield',

  data: () => ({
    areas: areas.sort((a, b) =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase())
    ),
    times: times.sort((a, b) =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase())
    ),
    weathers: weathers.sort((a, b) =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase())
    )
  })
}
</script>
